export const convertObjectValuesToStrings = (obj: Record<string, unknown>) =>
  Object.entries(obj).reduce<Record<string, string>>((map, [key, value]) => {
    map[key] = `${value}`;
    return map;
  }, {});

type NestedObject = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export const flattenObject = (inputObj: NestedObject): NestedObject => {
  const result: NestedObject = {};

  const flatten = (currentObj: NestedObject, parentKey = ''): void => {
    Object.keys(currentObj).forEach((key) => {
      const newKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof currentObj[key] === 'object' && currentObj[key] !== null && !Array.isArray(currentObj[key])) {
        flatten(currentObj[key], newKey);
      } else {
        result[newKey] = currentObj[key];
      }
    });
  };

  flatten(inputObj); // Call the internal flatten function
  return result;
};
